import { TestDefinition, QuestionType } from '../../types';
import { bssiScale } from './shared/scales';

export const TESTS_RIESGO_SUICIDA: TestDefinition[] = [
{
    id: 'c-ssrs-screener',
    code: 'C-SSRS',
    name: 'Columbia-Suicide Severity Rating Scale (Screener)',
    category: 'Suicide Risk',
    description: 'A suicide risk assessment scale. 6-item screener version for detection and evaluation of suicidal ideation and behavior severity.',
    questions: [
      {
        id: 'q1',
        text: '1. Wish to be Dead: Have you wished you were dead or wished you could go to sleep and not wake up?',
        type: QuestionType.YES_NO,
        options: [{ label: 'No', value: 0 }, { label: 'Yes', value: 1 }]
      },
      {
        id: 'q2',
        text: '2. Non-Specific Active Suicidal Thoughts: Have you actually had any thoughts of killing yourself?',
        type: QuestionType.YES_NO,
        options: [{ label: 'No', value: 0 }, { label: 'Yes', value: 1 }]
      },
      {
        id: 'q3',
        text: '3. Active Suicidal Ideation with Any Methods (Not Plan) without Intent to Act: Have you been thinking about how you might do this?',
        type: QuestionType.YES_NO,
        options: [{ label: 'No', value: 0 }, { label: 'Yes', value: 1 }]
      },
      {
        id: 'q4',
        text: '4. Active Suicidal Ideation with Some Intent to Act, without Specific Plan: Have you had these thoughts and had some intention of acting on them?',
        type: QuestionType.YES_NO,
        options: [{ label: 'No', value: 0 }, { label: 'Yes', value: 1 }]
      },
      {
        id: 'q5',
        text: '5. Active Suicidal Ideation with Specific Plan and Intent: Have you started to work out or worked out the details of how to kill yourself? Do you intend to carry out this plan?',
        type: QuestionType.YES_NO,
        options: [{ label: 'No', value: 0 }, { label: 'Yes', value: 1 }]
      },
      {
        id: 'q6',
        text: '6. Suicidal Behavior: Have you done anything, started to do anything, or prepared to do anything to end your life?',
        type: QuestionType.YES_NO,
        options: [{ label: 'No', value: 0 }, { label: 'Yes', value: 1 }]
      }
    ],
    interpretations: [
      { min: 0, max: 0, label: 'No Risk', color: 'bg-green-100 text-green-800' },
      { min: 1, max: 2, label: 'Low Risk', color: 'bg-yellow-100 text-yellow-800' },
      { min: 3, max: 4, label: 'Moderate Risk', color: 'bg-orange-100 text-orange-800' },
      { min: 5, max: 6, label: 'High/Severe Risk', color: 'bg-red-200 text-red-900' },
    ]
  },
{
    id: 'bssi-full',
    code: 'BSSI',
    name: 'Beck Scale for Suicide Ideation (Complete)',
    category: 'Suicide Risk',
    description: 'Comprehensive assessment of suicidal ideation, planning, and intent (21 items).',
    questions: [
      { id: 'b1', text: '1. Wish to Live', type: QuestionType.LIKERT, options: bssiScale('Moderate to strong', 'Weak', 'None') },
      { id: 'b2', text: '2. Wish to Die', type: QuestionType.LIKERT, options: bssiScale('None', 'Weak', 'Moderate to strong') },
      { id: 'b3', text: '3. Reasons for Living/Dying', type: QuestionType.LIKERT, options: bssiScale('Living > Dying', 'Living = Dying', 'Dying > Living') },
      { id: 'b4', text: '4. Desire to Make Active Suicide Attempt', type: QuestionType.LIKERT, options: bssiScale('None', 'Weak', 'Moderate to strong') },
      { id: 'b5', text: '5. Passive Suicidal Desire', type: QuestionType.LIKERT, options: bssiScale('Would take precautions to save life', 'Would leave life/death to chance', 'Would avoid steps to save life') },
      { id: 'b6', text: '6. Duration of Suicidal Thoughts', type: QuestionType.LIKERT, options: bssiScale('Brief, fleeting', 'Longer periods', 'Continuous or near continuous') },
      { id: 'b7', text: '7. Frequency of Ideation', type: QuestionType.LIKERT, options: bssiScale('Rare/Occasional', 'Frequent', 'Continuous') },
      { id: 'b8', text: '8. Attitude Toward Ideation', type: QuestionType.LIKERT, options: bssiScale('Rejection', 'Ambivalence', 'Acceptance') },
      { id: 'b9', text: '9. Control Over Suicidal Action', type: QuestionType.LIKERT, options: bssiScale('Has control', 'Unsure of control', 'No control') },
      { id: 'b10', text: '10. Deterrents (family, religion)', type: QuestionType.LIKERT, options: bssiScale('Would not attempt due to deterrents', 'Some concern about deterrents', 'Minimal/no concern') },
      { id: 'b11', text: '11. Reasons for Attempt', type: QuestionType.LIKERT, options: bssiScale('Manipulate environment/Attention', 'Combination', 'Escape/Final solution') },
      { id: 'b12', text: '12. Specificity of Plan', type: QuestionType.LIKERT, options: bssiScale('None', 'Considered, not worked out', 'Complete plan') },
      { id: 'b13', text: '13. Availability of Method', type: QuestionType.LIKERT, options: bssiScale('Method not available', 'Takes time to obtain', 'Available') },
      { id: 'b14', text: '14. Ability to Carry Out Attempt', type: QuestionType.LIKERT, options: bssiScale('No courage/competence', 'Unsure of ability', 'Sure of competence') },
      { id: 'b15', text: '15. Expectancy of Actual Attempt', type: QuestionType.LIKERT, options: bssiScale('No', 'Uncertain', 'Yes') },
      { id: 'b16', text: '16. Preparation for Attempt', type: QuestionType.LIKERT, options: bssiScale('None', 'Partial/minimal', 'Complete') },
      { id: 'b17', text: '17. Suicide Note', type: QuestionType.LIKERT, options: bssiScale('None', 'Thought of writing/started', 'Completed') },
      { id: 'b18', text: '18. Final Acts in Anticipation (will, insurance)', type: QuestionType.LIKERT, options: bssiScale('None', 'Thought about/arranged some', 'Made definite arrangements') },
      { id: 'b19', text: '19. Deception/Concealment', type: QuestionType.LIKERT, options: bssiScale('Revealed ideas', 'Avoided revealing', 'Attempted to deceive/hide/lie') },
      { id: 'b20', text: '20. Outcome of Attempt (screener)', type: QuestionType.LIKERT, options: bssiScale('Not applicable', 'Not applicable', 'Past attempt') },
      { id: 'b21', text: '21. Seriousness of Prior Attempt', type: QuestionType.LIKERT, options: bssiScale('No attempt', 'Manipulative', 'Serious with intent to die') }
    ],
    interpretations: [
      { min: 0, max: 5, label: 'Low Risk', color: 'bg-green-100 text-green-800' },
      { min: 6, max: 19, label: 'Moderate Risk', color: 'bg-yellow-100 text-yellow-800' },
      { min: 20, max: 28, label: 'High Risk', color: 'bg-orange-100 text-orange-800' },
      { min: 29, max: 38, label: 'Very High Risk', color: 'bg-red-200 text-red-900' },
    ]
  }
];
